/**
 * Navigate to the route by window.location
 * @param route - relative to the domain e.g. "checkout"
 */
export function navigateWindow(route) {
    if (!window.location.href.includes(route)) {
        const url = new URL(route, window.location.origin);
        window.location.href = url.toString();
    }
}
